import { render, staticRenderFns } from "./businessBidScore.vue?vue&type=template&id=811af0d2&scoped=true"
import script from "./businessBidScore.vue?vue&type=script&lang=js"
export * from "./businessBidScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811af0d2",
  null
  
)

export default component.exports